import React from "react";
import { colors } from "../colors/color";
import { TextAvatar, TextAvatarProps } from "./TextAvatar";

export function CountAvatar({ count, size }: { 
    count: number, 
    size?: TextAvatarProps['size'] 
}): JSX.Element {
    return (
        <TextAvatar
            backgroundColor={count === 0 ? colors.avatar.backgroundMuted : colors.avatar.background}
            text={count.toString()}
            size={size || '20px'}
        />
    );
}